import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CallEventsService {
  url: string;
  constructor(private http: HttpClient,) { }

  getItems() {
    let params = new HttpParams()
      .set('TSType', '1')
      .set('PageNumber', '1')
      .set('TSBetween', '06/02/2019 18:00:00^06/02/2019 19:00:00')
      .set('Sort', 'descending');
    var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.url = environment.urlAddress + '/api/VquadData/GetVquadData'
    return this.http.get<any[]>(this.url, { params });
  }
}
